// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "page-component---src-pages-404-jsx": require("gatsby-module-loader?name=page-component---src-pages-404-jsx!/opt/build/repo/src/pages/404.jsx"),
  "page-component---src-pages-about-jsx": require("gatsby-module-loader?name=page-component---src-pages-about-jsx!/opt/build/repo/src/pages/about.jsx"),
  "page-component---src-pages-contact-jsx": require("gatsby-module-loader?name=page-component---src-pages-contact-jsx!/opt/build/repo/src/pages/contact.jsx"),
  "page-component---src-pages-index-jsx": require("gatsby-module-loader?name=page-component---src-pages-index-jsx!/opt/build/repo/src/pages/index.jsx")
}

exports.json = {
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "about.json": require("gatsby-module-loader?name=path---about!/opt/build/repo/.cache/json/about.json"),
  "contact.json": require("gatsby-module-loader?name=path---contact!/opt/build/repo/.cache/json/contact.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "index": require("gatsby-module-loader?name=layout-component---index!/opt/build/repo/src/layouts/index")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js